<div class="duna-cleaning-unique-links-container">
  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Unikke rengørings-links</h1></mat-card-title>
      <mat-card-subtitle>
        Opret anonyme organisatoriske tokens til den offentlige side <code>/cleaning/:uuid</code>. Flere links kan bruges til fx forskellige samarbejdspartnere.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-actions align="end">
      <button mat-raised-button color="primary" (click)="createLink()" [disabled]="creating || loading">
        {{ creating ? 'Opretter…' : 'Opret link' }}
      </button>
    </mat-card-actions>
  </mat-card>

  @if (errorMessage) {
    <mat-card class="message-card message-card--error">
      <mat-card-content>
        <p class="error-message">{{ errorMessage }}</p>
      </mat-card-content>
    </mat-card>
  }

  <mat-card class="table-card">
    <mat-card-header>
      <mat-card-title>Rengørings-links</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <table mat-table [dataSource]="tableDataSource" class="links-table">
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Oprettet</th>
          <td mat-cell *matCellDef="let row">{{ row.created_at ? (row.created_at | date : 'dd/MM/yyyy HH:mm') : '–' }}</td>
        </ng-container>

        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef>Link</th>
          <td mat-cell *matCellDef="let row">
            @if (absoluteLink(row); as link) {
              <a [href]="link" target="_blank" rel="noopener">{{ link }}</a>
            } @else {
              <span>–</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button mat-stroked-button color="primary" (click)="copyLink(row)" [disabled]="!row.link_uuid" matTooltip="Kopiér link">
              <mat-icon>content_copy</mat-icon>
              Kopiér
            </button>
            <button mat-stroked-button color="warn" class="delete-btn" (click)="deleteLink(row)" matTooltip="Slet link">
              <mat-icon>delete</mat-icon>
              Slet
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length">
            {{ loading ? 'Henter…' : 'Ingen links oprettet endnu.' }}
          </td>
        </tr>
      </table>

      @if (copiedLink) {
        <div class="copied-message">Link kopieret: {{ copiedLink }}</div>
      }
    </mat-card-content>
  </mat-card>
</div>
